import * as React from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
import styled from '@theme/styled-components'

import Icon from '@components/icon/Icons'

import theme from '@theme/Theme'

const RootHeader = ({ title, left = 'arrow-left', onLeft, right, onRight, renderSub, rightText }: HeaderProps) => {
  return (
    <MainContainer>
      <ContentContainer>
        <Button activeOpacity={0.9} onPress={onLeft}>
          {!!onLeft && !!left && <Icon name={left} size={35} color={theme.colors.background} />}
        </Button>

        <Title>{title || ''}</Title>

        <Button activeOpacity={0.9} onPress={onRight}>
          {!!right && <Icon name={right} size={35} color={theme.colors.background} />}
        </Button>
        {!!rightText && !!onRight && (
          <ButtonTextContainer onPress={onRight}>
            <ButtonText>{rightText}</ButtonText>
          </ButtonTextContainer>
        )}
      </ContentContainer>
      {!!renderSub && renderSub()}
    </MainContainer>
  )
}

export default RootHeader

const MainContainer = styled(View)`
  padding: 16px;
  background-color: ${(props) => props.theme.colors.primary};
  z-index: 10;
`

const ContentContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  height: 30px;
  margin-top: ${(props) => props.theme.insets.top}px;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  color: ${(props) => props.theme.colors.background};
  flex: 1;
  text-align: center;
`

const Button = styled(TouchableOpacity)`
  width: 30px;
  align-items: center;
`

const ButtonTextContainer = styled(TouchableOpacity)`
  width: 60px;
  align-items: center;
  border-radius: 4px;
  padding: 8px;
  background-color: ${(props) => props.theme.colors.primaryFocused};
`

const ButtonText = styled(Text)`
  ${(props) => props.theme.fonts.Caption2};
`
